export default "__VITE_ASSET__CLo$VJVp__"